
import es from './es'
import en from './en'
import cn from './zh-CN'
export default {
  es,
  en,
  cn
}



// WEBPACK FOOTER //
// ./src/i18n/lang/index.js